import {
  ROOM_SHARED,
  RESIDENCE,
  APARTMENT,
  STUDIO
} from '@spotahome/ui-library/src/tenant/data/common/property';

export const SECTION_ALL = 'all';
export const SECTION_STUDIO = 'studios';
export const SECTION_APARTMENT = 'apartments';
export const SECTION_ROOM = 'rooms';
export const SECTION_RESIDENCE = 'residences';

export const SECTION_PROPERTY_TYPE_MAP = {
  [SECTION_ALL]: null,
  [SECTION_STUDIO]: STUDIO,
  [SECTION_APARTMENT]: APARTMENT,
  [SECTION_ROOM]: ROOM_SHARED,
  [SECTION_RESIDENCE]: RESIDENCE
};

export const PROPERTY_TYPE_TO_SECTION_MAP = {
  [STUDIO]: SECTION_STUDIO,
  [APARTMENT]: SECTION_APARTMENT,
  [ROOM_SHARED]: SECTION_ROOM,
  [RESIDENCE]: SECTION_RESIDENCE
};

export const SECTION_PROPERTY_TYPE_LABEL_MAP = {
  [SECTION_ALL]: 'charts.section.all-properties',
  [SECTION_STUDIO]: 'charts.section.studios',
  [SECTION_APARTMENT]: 'charts.section.apartments',
  [SECTION_ROOM]: 'charts.section.rooms-shared',
  [SECTION_RESIDENCE]: 'charts.section.student-residences'
};

export const NATIONALITY = 'nationality';
export const OCCUPATION = 'occupation';
export const AGE = 'age';
